import { types } from 'mobx-state-tree';

const CatalogItemsPagination = types
  .model('CatalogItemsPagination', {
    pageSize: 120,
    pageNumber: 1,
    totalResults: types.maybe(types.number),
  })
  .actions(self => ({
    setPage(pg) {
      self.pageNumber = pg;
    },
    setTotalResults(t) {
      self.totalResults = t;
    },
    resetValues() {
      self.pageNumber = 1;
    },
  }));

export default CatalogItemsPagination;
